import { useState } from "react";
import { Modal } from "react-bootstrap";
import Spinner from "../Components/Spinner";
import ErrorMessage from "../Components/ErrorMessage";
import MandatorySign from "./MandatorySign";
import { MdCheck, MdOutlineCopyAll } from "react-icons/md";
import { useLanguage } from "../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const DeleteItemModal = ({
    account_id,
    show,
    handleClose,
    fetchRecords,
    item,
    endpoint,
    title,
    description,
    input_value
}) => {
    const { t } = useLanguage()
    const [loadingSave, setLoadingSave] = useState(false);
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });
    const [inputValue, setInputValue] = useState("")
    const [checkCopy, setCheckCopy] = useState(false)

    const confirmText = (input_value?.name && input_value.name.trim())
        ? input_value.name.trim()
        : t.delete;

    const handleSave = async () => {
        if (!inputValue.trim()) {
            setErrorMessage({
                message: `${t.type_confirm} "${confirmText}".`,
                display: true
            });
            return;
        }

        if (inputValue.trim() !== confirmText) {
            setErrorMessage({
                message: t.delete_modal.error_val_match,
                display: true
            });
            return;
        }

        setLoadingSave(true);
        setErrorMessage({ message: "", display: false });

        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/${endpoint}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    account_id: account_id,
                    item_id: item.id,
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                setErrorMessage({
                    message: "Failed to delete the item. Please try again.",
                    display: true
                });
                throw new Error("Failed to delete the item. Please try again.");
            }

            if (data.message == "OK") {
                closeModal();
                if (fetchRecords) {
                    await fetchRecords();
                }
            }

        } catch (error) {
            setErrorMessage({
                message: "Something went wrong while deleting. Please try again.",
                display: true
            });
        } finally {
            setLoadingSave(false);
        }
    };

    const copyItem = (item) => {
        navigator.clipboard.writeText(item)
            .then(() => {
                setCheckCopy(true);
                setTimeout(() => {
                    setCheckCopy(false);
                }, 2000);
            })
            .catch((err) => {
                console.error("Failed to copy: ", err);
            });
    };


    const closeModal = () => {
        handleClose();
        setErrorMessage({ message: "", display: false });
        setLoadingSave(false);
        setInputValue("")
    };

    return (
        <Modal show={show} centered onHide={closeModal}>
            <div className="modal_header">
                <p className="modal_header_title">{title}</p>
            </div>

            <div className="modal_main_cont">
                <div className="warning_message_cont">
                    <p className="warning_message_description">
                        {description}
                    </p>
                </div>
                <div className="modal_profile_input_cont">
                    <div className="label_input">
                        <label className="input_label">
                            {t.type_confirm} "<strong>{confirmText}</strong>"
                            <button className="path_item_root_btn" title="Copy" onClick={() => copyItem(confirmText)}>{checkCopy ? <i className="fade-in"> <MdCheck /></i> : <i className="fade-in"><MdOutlineCopyAll /></i>}</button>

                        </label>
                        <input
                            type="text"
                            name="name"
                            maxLength={100}
                            placeholder={`${t.type_confirm} "${confirmText}"`}
                            className="register_form_first fade-in"
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            autoComplete="off"
                        />
                    </div>
                </div>
            </div>

            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                    <ErrorMessage err={errorMessage} />
                </div>

                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_delete_btn"
                        onClick={handleSave}
                        disabled={loadingSave || inputValue.trim() !== confirmText}
                    >
                        {loadingSave ? <Spinner loading={true} /> : t.delete}
                    </button>

                    <button
                        className="modale_close_btn"
                        onClick={closeModal}
                        disabled={loadingSave}
                    >
                        {t.close}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default DeleteItemModal;